module.exports = __webpack_public_path__ + "img/side-image.c5b2f1c6.png";